import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {codGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  base: {
    flex: 1,
    backgroundColor: white,
  },
  title: {
    textAlign: 'center',
    color: codGray,
    fontWeight: '600',
  },
  description: {
    textAlign: 'center',
    marginTop: indent * 0.8,
    color: codGray,
  },
  logo: {
    width: '100%',
  },
  logoContainer: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    height: 57,
    width: '100%',
    marginBottom: 40,
  },
  constructionContainer: {
    width: '100%',
    height: '40%',
    maxHeight: 240,
    marginBottom: indent * 1.6,
    marginTop: indent * 2.25,
  },
  construction: {
    width: '100%',
    height: '100%',
  },
  button: {
    width: '100%',
    marginTop: indent * 1.6,
    paddingVertical: indent * 0.6,
  },
});
